import registerLink from '../../../common/links/index';
import presentationalComponent from './Link';
import containerComponent from './LinkContainer';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';

export default () =>
    registerLink({
        containerComponent,
        presentationalComponent,
        tools: [TOOLS.RICH_TEXT, TOOLS.COLOR, TOOLS.MEDIA, { ...TOOLS.CAPTION, name: 'Description' }, TOOLS.REACTION],
    });
